import { Card, CardContent, Chip, ChipProps, Stack, Typography } from "@mui/material";
import * as React from "react";

interface Props {
  icon: React.ReactNode
  title: string
  status: string
  statusColor?: ChipProps["color"]
  children: React.ReactNode
}

export default function StoreSetupCard(props: Props) {
  return <Card elevation={0}>
    <CardContent sx={{ p: 3 }}>
      <Stack spacing={2.5}>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            {props.icon}
            <Typography variant="h4">{props.title}</Typography>
          </Stack>
          <Chip
            label={props.status}
            color={props.statusColor ?? "default"}
            variant="outlined"
            size="small"
          />
        </Stack>

        {props.children}
      </Stack>
    </CardContent>
  </Card>;
}
